<template>
  <Container :class="dark && 'bg-accent-dark'">
    <h2
      v-if="title.length > 0"
      class="text-center text-accent"
      :class="dark && 'text-white'"
    >
      {{ title }}
    </h2>
    <div class="grid gap-x-8 gap-y-12" :class="`lg:grid-cols-2`">
      <section class="flex" :class="flip && `lg:order-1 lg:py-12`">
        <p class="my-auto" :class="dark && 'text-white'"><span v-html="description"></span></p>
      </section>
      <section>
        <div class="split-img-wrapper w-full h-full rounded-md overflow-hidden">
          <slot></slot>
        </div>
      </section>
    </div>
  </Container>
</template>

<script>
import Container from "@/components/base/Container.vue";
export default {
  components: { Container },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    description: {
      type: String,
      default: "Description",
    },
    flip: {
      type: Boolean,
      default: false,
    },
    breakpoint: {
      type: String,
      default: "md",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.split-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
